import React from "react";

const MessagesBlock = React.forwardRef(({ children, ...props }, ref) => {
  return (
    <div className="messages" ref={ref} {...props}>
      {children}
    </div>
  );
});

export default MessagesBlock;
